import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../constants';
import { useAuth } from '../useAuth';
import dashboardController, {
  SalesDashboardAccess,
} from '../../services/api/dashboardController';

type AuthLike = { tokens?: { idToken?: { jwtToken?: string } } };

export const useSalesDashboardAccess = () => {
  const auth = useAuth();
  const authToken = (auth as AuthLike)?.tokens?.idToken?.jwtToken ?? '';

  return useQuery<SalesDashboardAccess>({
    queryKey: QUERY_KEYS.SALES_DASHBOARD_ACCESS,
    queryFn: async () => {
      const response =
        await dashboardController.getSalesDashboardAccess(authToken);
      return response?.data;
    },
    enabled: Boolean(authToken),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
